<template>
  <section id="about">
    <div class="reveal">
      <div class="section-label">{{ m.about.label }}</div>
      <h2>{{ m.about.titleLine1 }}<br><em>{{ m.about.titleLine2 }}</em> {{ m.about.titleLine3 }}</h2>
      <p class="about-text">{{ m.about.text1 }}</p>
      <p class="about-text">{{ m.about.text2 }}</p>
      <div class="standards">
        <span class="std-tag">EN54</span>
        <span class="std-tag">VdS</span>
        <span class="std-tag">Grade 3</span>
      </div>
    </div>
    <div class="about-right reveal" style="transition-delay:.15s">
      <div class="about-img-wrapper">
        <img class="about-img" src="/img/ref2.jpg" :alt="m.about.imageAlt">
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { messages: m } = useI18n()
</script>